import { isEmptyObject, isNotEmptyString } from "../helpers/JsHelper";
import text from "recharts/lib/component/Text";

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */

export const DEVELOPMENT = false;

// Methods
export const POST = 'POST';
export const GET = 'GET';
export const DELETE = 'DELETE';
export const PUT = 'PUT';

// Headers 

//   *) Common Keys
export const ACCEPT = 'Accept';
export const CONTENT_TYPE = 'Content-Type';

//   *) Common Values
export const APPLICATION_JSON = 'application/json';

//   *) Common Headers for Methods
export const POST_HEADERS = {
    [ACCEPT]: APPLICATION_JSON,
    [CONTENT_TYPE]: APPLICATION_JSON
}

export const GET_HEADERS = {
    [ACCEPT]: APPLICATION_JSON
}

export const DELETE_HEADERS = {
    [ACCEPT]: APPLICATION_JSON
}

export const DELETE_HEADERS_BODY = {
    [ACCEPT]: APPLICATION_JSON,
    [CONTENT_TYPE]: APPLICATION_JSON
}

export const PUT_HEADERS = {
    [ACCEPT]: APPLICATION_JSON,
    [CONTENT_TYPE]: APPLICATION_JSON
}

export class HttpError extends Error {
   constructor(code, message) {
     super(isNotEmptyString(message) ? message : ERROR_MESSAGES[code]); // (1)
     this.code = code; // (2)
     // console.log("HTTP Error [" + code + "]: " + message);
   }
}

const ERROR_MESSAGES = {
    100: "Continue",
    101: "Switching Protocols",
    102: "Processing",
    103: "Early Hints",
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    207: "Multi-Status",
    208: "Already Reported",
    226: "IM Used",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    307: "Temporary Redirect",
    308: "Permanent Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Failed",
    413: "Payload Too Large",
    414: "URI Too Long",
    415: "Unsupported Media Type",
    416: "Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a Teapot",
    421: "Misdirected Request",
    422: "Unprocessable Entity",
    423: "Locked",
    424: "Failed Dependency",
    425: "Too Early",
    426: "Upgrade Required",
    428: "Precondition Required",
    429: "Too Many Requests",
    431: "Request Header Fields Too Large",
    451: "Unavailable For Legal Reasons",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported",
    506: "Variant Also Negotiates",
    507: "Insufficient Storage",
    508: "Loop Detected",
    509: "Bandwidth Limit Exceeded",
    510: "Not Extended",
    511: "Network Authentication Required"
};

export function createUrlWithParams(path, params) {
    if (isEmptyObject(params))
        return path;
    if(path.includes('?')){
        return `${path}&${new URLSearchParams(params)}`
    }
    return `${path}?${new URLSearchParams(params)}`;
}

export function raiseError(response, expected) {

    let toRaise = false;

    if (Array.isArray(expected)) {
        if (expected.indexOf(response.status) === -1) {
            toRaise = true;
        }
    } else if (response.status !== expected) {
        toRaise = true;
    }

    if (toRaise) {
        throw new HttpError(parseInt(response.status), response.statusText);
    }

}

export function fecthWithTimeout(url, options, timeout) {
    return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
            setTimeout(() => reject(new Error('timeout')), timeout || 15000)
        )
    ]);
}

export function handleErrorFetch(context) {
    const newContext = Object.assign({}, context);
    newContext.userProfileLoaded = true;
    newContext.userProfile = { authorized: true };
    return newContext;
}

export async function get(url, body) {
    const response = await fetch(url, {
        method: GET,
        headers: GET_HEADERS,
        body: JSON.stringify(body)
    });
    raiseError(response, [200]);

    return response.json();
}

export async function getNoJson(url) {
    const response = await fetch(url, {
        method: GET,
        headers: GET_HEADERS
    });
    raiseError(response, [200]);

    if (response.status === 200) {
        return response;
    }
    return;
}

export async function remove(url, body) {
    const response = await fetch(url, {
        method: DELETE,
        headers: body ? DELETE_HEADERS_BODY : DELETE_HEADERS,
        body: JSON.stringify(body || {})
    });
    raiseError(response, [200, 204]);
    if (response.status === 200) {
        return response
            .text()
            .then((text) => {
                if (text) {
                    return JSON.parse(text);
                }
                return null;
            });
    }
}

export async function put(url, body) {

    const response = await fetch(url, {
        method: PUT,
        headers: PUT_HEADERS,
        body: JSON.stringify(body)
    });

    raiseError(response, [200, 204]);

    if (response.status === 200) {
        return response.json();
    }

    return;


}



export async function post(url, body) {

    const response = await fetch(url, {
        method: POST,
        headers: POST_HEADERS,
        body: JSON.stringify(body)
    });

    raiseError(response, [200, 204]);

    if (response.status === 200) {
        return response.json();
    }

    return;


}